import InfoSection from './InfoSection';
import UserDetailMap from './UserDetailMap';

import classes from './infoTab.module.css';

const InfoTab = () => {
  return (
    <div className={classes.infoTabContainer}>
      <InfoSection />
      <div className={classes.rightPane}>
        <UserDetailMap />
      </div>
    </div>
  );
};

export default InfoTab;
